var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-entity-search-template"},[_c('div',{staticClass:"row item-template-header"},[_c('div',{staticClass:"col",staticStyle:{"padding-left":"15px"}},[_c('b',[_vm._v(_vm._s(_vm.item.text))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }